module.exports = __webpack_public_path__ + "static/media/smoothie_paper_straw2.536b6696.png";